import React from 'react';
import Icon from './icon';

function LogoPeque(props) {
  return (
    <Icon {...props}>
      <g>
  	<path class="st0" d="M25.7,206.9c-7.6-3-13.7-7.6-18.3-13.6c-4.6-6-7-13.2-7.1-21.6c0-1,0.3-1.9,1-2.7c0.7-0.7,1.5-1.1,2.6-1.1
  		h24.6c1.6,0,2.9,0.4,3.8,1.1c0.9,0.7,1.7,2,2.2,3.7c1.8,8.6,7.4,12.9,16.8,12.9c5.5,0,9.7-1.8,12.6-5.4c2.9-3.6,4.4-8.9,4.4-15.7
  		v-48.5H13.2c-1.1,0-2.1-0.4-3-1.3c-0.9-0.9-1.3-1.9-1.3-3v-18c0-1.3,0.4-2.3,1.3-3.1c0.9-0.8,1.9-1.2,3-1.2h84
  		c1.3,0,2.3,0.4,3.2,1.3c0.9,0.9,1.3,1.9,1.3,3.2v71.7c0,9.7-2.1,18.1-6.4,25c-4.3,6.9-10.3,12.1-18,15.6s-16.6,5.2-26.7,5.2
  		C41.5,211.4,33.3,209.9,25.7,206.9z"/>
  	<path class="st0" d="M125.3,208.5c-0.9-0.8-1.3-1.8-1.3-3.1V93.9c0-1.3,0.4-2.3,1.3-3.2c0.9-0.9,1.9-1.3,3.2-1.3h19.4
  		c2.9,0,4.9,1.3,6.2,3.8l29.6,52.9l29.7-52.9c1.3-2.5,3.3-3.8,6.2-3.8H239c1.3,0,2.3,0.4,3.2,1.3c0.9,0.9,1.3,1.9,1.3,3.2v111.5
  		c0,1.3-0.4,2.3-1.3,3.1c-0.9,0.8-1.9,1.2-3.2,1.2h-21.8c-1.1,0-2.1-0.4-3-1.3c-0.9-0.9-1.3-1.9-1.3-3v-62.6l-18.6,34
  		c-1.5,2.6-3.5,4-6,4H179c-2.3,0-4.3-1.3-6-4l-18.4-34v62.6c0,1.3-0.4,2.3-1.3,3.1c-0.9,0.8-1.9,1.2-3.2,1.2h-21.7
  		C127.2,209.7,126.2,209.3,125.3,208.5z"/>
  	<path class="st0" d="M268.1,208.4c-0.9-0.9-1.3-1.9-1.3-3V93.7c0-1.3,0.4-2.3,1.3-3.1c0.9-0.8,1.9-1.2,3-1.2h24.6
  		c1.3,0,2.3,0.4,3.1,1.2c0.8,0.8,1.2,1.8,1.2,3.1v111.7c0,1.1-0.4,2.1-1.2,3s-1.8,1.3-3.1,1.3h-24.6
  		C270,209.7,269,209.3,268.1,208.4z"/>
  </g>
    </Icon>
  )
}

export default LogoPeque;



// WEBPACK FOOTER //
// ./src/icons/components/logoPeque.js